// Module
var code = "<div class=\"steps-counter\" ng-show=\"$ctrl.visible\" ng-bind=\"$ctrl.message\"></div>";
// Exports
module.exports = code;